import React, { useState } from 'react';

import { Modal, BlockStack, Text, TextField, Checkbox } from '@shopify/polaris';

const NewUserDialog = ({ displayNewUserDialog, setDisplayNewUserDialog, createUser, setSubmitted }) => {
  const [email, setEmail] = useState('');
  const [loginName, setLoginName] = useState('');
  const [picker, setPicker] = useState(false);
  const [packer, setPacker] = useState(false);
  const [stockReturn, setStockReturn] = useState(false);

  const userJson = () => {
    return {
      email: email,
      login_name: loginName,
      permissions: {
        picker: picker,
        packer: packer,
        stock_return: stockReturn
      }
    }
  }

  const create = () => {
    createUser(userJson());
    setSubmitted(true);
    setDisplayNewUserDialog(false);

    close();
  }


  const close = () => {
    setPicker(false);
    setPacker(false);
    setStockReturn(false);

    setDisplayNewUserDialog(false);
  }

  return(
    <Modal
      open={displayNewUserDialog}
      onClose={() => close()}
      title="New User"
      primaryAction={{
        content: 'New User',
        onAction: () => create(),
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: () => close()
        },
      ]}
    >
      <Modal.Section>
        <BlockStack gap="400">
          <Text as="h3" variant="headingSm">User Details</Text>

          <TextField
            label="Email"
            value={email}
            onChange={setEmail}
            placeholder="Email"
            autoComplete="off"
            requiredIndicator
          />

          <TextField
            label="Login Name"
            value={loginName}
            onChange={setLoginName}
            placeholder="Login Name"
            autoComplete="off"
            requiredIndicator
          />

          <Text as="h3" variant="headingSm">User Permissions</Text>

          <Checkbox
            label='Picker'
            checked={picker}
            onChange={setPicker}
          />

          <Checkbox
            label='Packer'
            checked={packer}
            onChange={setPacker}
          />

          <Checkbox
            label='Stock Returns'
            checked={stockReturn}
            onChange={setStockReturn}
          />
        </BlockStack>
      </Modal.Section>
    </Modal>
  )
}

export default NewUserDialog;
